import { styled } from '@mui/material';

import { useState } from 'react';

import { ArrowForwardIcon, CloseIcon } from '@app-velocity/icons';

import { ViewPreview } from '../../../../components/ViewPreview';
import { SinglePath } from '../../../../types';

const LightboxContainer = styled('div')({
  position: 'fixed',
  zIndex: 9999,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  left: 0,
  top: 0,
});

const LightboxBackdrop = styled('div')({
  position: 'absolute',
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.85)',
  zIndex: 1,
});

const ViewContainer = styled('div')({
  position: 'relative',
  zIndex: 1,
});

const CloseButton = styled('button')({
  position: 'absolute',
  top: 16,
  right: 16,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'block',
  svg: {
    fill: '#fff',
  },
  zIndex: 2,
});

const RightButton = styled('button')({
  position: 'absolute',
  top: '50%',
  right: 16,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  svg: {
    fill: '#fff',
    width: 20,
    height: 20,
  },
  zIndex: 2,
});

const LeftButton = styled('button')({
  position: 'absolute',
  top: '50%',
  left: 16,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  transform: 'rotate(180deg)',
  svg: {
    fill: '#fff',
    width: 20,
    height: 20,
  },
  zIndex: 2,
});

export type LightboxProps = {
  viewIndex: number;
  path: SinglePath;
  onClose: () => void;
};

export const Lightbox = ({ viewIndex, path, onClose }: LightboxProps) => {
  const [displayedViewIndex, setDisplayedViewIndex] = useState(viewIndex);

  const handleNextScreen = () => {
    if (displayedViewIndex < path.views.length - 1) {
      setDisplayedViewIndex((prev) => prev + 1);
    } else {
      setDisplayedViewIndex(0);
    }
  };

  const handlePrevScreen = () => {
    if (displayedViewIndex > 0) {
      setDisplayedViewIndex((prev) => prev - 1);
    } else {
      setDisplayedViewIndex(path.views.length - 1);
    }
  };

  const view = path.views[displayedViewIndex];

  return (
    <LightboxContainer>
      <LightboxBackdrop onClick={onClose} />
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
      <RightButton onClick={handleNextScreen}>
        <ArrowForwardIcon />
      </RightButton>
      <LeftButton onClick={handlePrevScreen}>
        <ArrowForwardIcon />
      </LeftButton>
      <ViewContainer>
        <ViewPreview
          persona={path.persona || 'default'}
          personaConfig={path.personaConfig}
          size="full"
          pageId={view.pageId}
          partials={view.partials}
          clicks={view.clicks}
          image={view.image}
          width={view.width}
          height={view.height}
        />
      </ViewContainer>
    </LightboxContainer>
  );
};
